export default __webpack_public_path__ + "static/media/landing-page-mobile.70a4c8e1.svg";